import React from 'react';
import { connect } from "react-redux";
import * as fileCrud from '../../../../crud/file.crud';
import Document from '../../_CustomComponents/DocumentV2';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import { Alert } from "react-bootstrap";
import { withSnackbar } from 'notistack';
import * as projectsCrud from '../../../../crud/projects.crud';
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';



class NotifyDocumentPage extends BaseDocument {
    constructor(props) {
        super(props);
        this.itqRelationRequired = props.itqRelationRequired;
        this.isAsiteEnabled = process.env.REACT_APP_ASITE_ENABLED === 'true';
    }

    calculateTotal = (obj) => {
        const prc1 = obj.pricelisttotal ? obj.pricelisttotal : 0;
        const prc2 = obj.compensationeventtotal ? obj.compensationeventtotal : 0;
        return prc1 + prc2;
    }
    getProjectOptions = () => {
        const { companyid } = this.props.contract;
        const datasource = {
            loadMode: 'raw',
            cacheRawData: true,
            load: () => {
                var promise = new Promise((resolve, reject) => {
                    projectsCrud.getCutDownProjectsList(companyid)
                        .then(response => {
                            let projectList = [];
                            if (response.data && response.data.length > 0) {
                                projectList = response.data.map(project => ({ projectid: project.projectid, display: (project.projectcode ? `[${project.projectcode}] - ` : "") + `${project.name}` }));
                            }
                            else {
                                this.props.enqueueSnackbar('No project found for selected the company', { variant: 'warning', });
                            }
                            resolve(projectList);
                        })
                        .catch(err => {
                            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                            reject(err);
                        });
                });
                return promise;
            }
        }
        return datasource;
    }
    renderForm = () => {
        const { fields } = this.props.workflowItem;

        const editorFormConfig = {
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: [
                { resource: 'GENERAL.FORMS.FIELD.SUBJECT', dataField: 'subject' },
                { note: this.props.resources.Note }
            ]
        };
        if (fields.ProjectRelation.visible) {
            editorFormConfig.fields.push({ label: fields.ProjectRelation.label, dataField: 'linkedprojectid', required: fields.ProjectRelation.required, editorType: 'dxSelectBox', editorOptions: { dataSource: this.getProjectOptions(), valueExpr: 'projectid', displayExpr: 'display' } });
        }
        if (fields.ProjectOrderNumber.visible) {
            editorFormConfig.fields.push({ label: fields.ProjectOrderNumber.label, dataField: 'projectordernumber', required: fields.ProjectOrderNumber.required });
        }
        if (fields.PurchaseOrderValue.visible) {
            editorFormConfig.fields.push({ label: fields.PurchaseOrderValue.label, dataField: 'purchaseordervalue', required: fields.PurchaseOrderValue.required, editorType: 'dxNumberBox' });
        }
        if (fields.ItqRelation.visible) {
            const itqRelationField = { label: fields.ItqRelation.label, dataField: 'instructiontoquoteid', required: false, editorType: 'dxSelectBox', editorOptions: { dataSource: this.props.itqs, valueExpr: 'value', displayExpr: 'display' } };

            if (fields.ItqRelation.required) {
                itqRelationField.validation = { type: 'custom', validationCallback: (obj, value) => (value), warning: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_ITQ_REQUIRED_COMMUNICATING' }, { PROJECT_ORDER: this.props.proNotificationName, ITQ: this.props.itqNotificationName }) }
            }

            editorFormConfig.fields.push(itqRelationField);
        }
        if (fields.Description.visible) {
            editorFormConfig.fields.push({ label: fields.Description.label, dataField: 'description', editorType: 'dxHtmlEditor' })
        }
        if (fields.Comments.visible) {
            editorFormConfig.fields.push({ label: fields.Comments.label, dataField: 'comments', editorType: 'dxHtmlEditor' })
        }
        if (fields.ItemsList.visible) {
            editorFormConfig.fields.push({ label: fields.ItemsList.label, dataField: 'pricelistdescription' })
        }
        if (fields.TotalListPrice.visible) {
            editorFormConfig.fields.push({ label: fields.TotalListPrice.label, dataField: 'pricelisttotal', editorType: 'dxNumberBox' })
        }
        if (fields.CompensationDescription.visible) {
            editorFormConfig.fields.push({ label: fields.CompensationDescription.label, dataField: 'compensationeventdescripton' })
        }
        if (fields.TotalAssessed.visible) {
            editorFormConfig.fields.push({ label: fields.TotalAssessed.label, dataField: 'compensationeventtotal', editorType: 'dxNumberBox' })
        }
        if (fields.TotalPrice.visible) {
            editorFormConfig.fields.push({ label: fields.TotalPrice.label, dataField: 'projectordertotal', editorType: 'dxNumberBox', value: this.calculateTotal })
        }
        if (fields.StartDate.visible) {
            const startDateField = { label: fields.StartDate.label, dataField: 'startdate', editorType: 'dxDateBox', validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } };
            if (fields.CompletionDate.visible) {
                startDateField.validation = { type: 'custom', validationCallback: (obj, value) => (obj.completiondate >= value), warning: 'Completion date can not be earlier than start date' }
            }
            editorFormConfig.fields.push(startDateField)
        }
        if (fields.CompletionDate.visible) {
            const completionDateField = { label: fields.CompletionDate.label, dataField: 'completiondate', editorType: 'dxDateBox', validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } }
            if (fields.StartDate.visible) {
                completionDateField.validation = { type: 'custom', validationCallback: (obj, value) => (obj.startdate <= value), warning: 'Completion date can not be earlier than start date' }
            }
            editorFormConfig.fields.push(completionDateField)
        }
        if (fields.DelayAmount.visible) {
            editorFormConfig.fields.push({ label: fields.DelayAmount.label, dataField: 'delaydamagestotal', editorType: 'dxNumberBox' })
            editorFormConfig.fields.push({ label: fields.DelayPaymentPeriod.label, dataField: 'delaydamagestype', editorType: 'dxSelectBox', editorOptions: { dataSource: this.props.paymentPeriods } })
        }
        if (fields.BonusRate.visible) {
            editorFormConfig.fields.push({ label: fields.BonusRate.label, dataField: 'bonusrate' })
        }
        if (fields.BonusCalculationPeriod.visible) {
            editorFormConfig.fields.push({ label: fields.BonusCalculationPeriod.label, dataField: 'bonuscalculationperiod', editorType: 'dxSelectBox', editorOptions: { dataSource: this.props.calculationPeriods } })
        }

        return (
            <>
                {this.props.resources.WarningBanner && (
                    <Alert variant="warning" >
                        <p>
                            {this.props.resources.WarningBanner}
                        </p>
                    </Alert>
                )}
                <BiDynamicForm
                    item={this.props.notification}
                    valueChangeHandler={this.props.fieldChanged}
                    config={editorFormConfig}
                    customFields={(this.props.customFields || {}).COMMUNICATION}
                    assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
                />
            </>
        );
    }

    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType, this.props.notification.projectorderid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }



    render() {
        const documentIsFinal = this.props.notification.showtasknotification === 1;
        const { createby, createdate, lastdraftedbyname, lastdrafteddate, lastdraftednotifiedtoname } = this.props.notification;

        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={createby}
                    createdate={createdate}
                    lastdraftedbyname={lastdraftedbyname}
                    lastdrafteddate={lastdrafteddate}
                    lastdraftednotifiedtoname={lastdraftednotifiedtoname}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.referenceid}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    customFields={(this.props.customFields || {}).COMMUNICATION}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.notification.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                />
            </>

        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
});

export default withSnackbar(connect(mapStateToProps)(NotifyDocumentPage));
